import { PrismTheme } from 'prism-react-renderer';

const codeExampleTheme: PrismTheme = {
  plain: {
    color: '#e8ffe6',
    backgroundColor: '#050f08',
  },
  styles: [
    {
      types: ['comment', 'prolog', 'doctype', 'cdata'],
      style: {
        color: '#4a6b55',
        fontStyle: 'italic',
      },
    },
    {
      types: ['punctuation'],
      style: {
        color: '#8bb89b',
      },
    },
    {
      types: ['keyword', 'control', 'directive'],
      style: {
        color: '#7fffa7',
      },
    },
    {
      types: ['builtin', 'class-name', 'constant'],
      style: {
        color: '#8ad5ff',
      },
    },
    {
      types: ['function', 'method'],
      style: {
        color: '#6fe4c0',
      },
    },
    {
      types: ['string', 'char'],
      style: {
        color: '#ffd479',
      },
    },
    {
      types: ['number', 'boolean'],
      style: {
        color: '#ff9e86',
      },
    },
    {
      types: ['operator'],
      style: {
        color: '#9ad3b3',
      },
    },
    {
      types: ['variable', 'property'],
      style: {
        color: '#d1ffe3',
      },
    },
    {
      types: ['attr-name', 'symbol'],
      style: {
        color: '#ffbfb3',
      },
    },
  ],
};

export default codeExampleTheme;
